/* @flow */

import { createSelector } from '@reduxjs/toolkit';
import { hydrateEvent } from '@e180/domain/lib/event/util';

import type {
  BraindateEvent,
  BraindateEventPublicData,
} from '@e180/domain/lib/event/type';
import type { State } from 'src/shared/core/type/reduxTypes';

/*
 |------------------------------------------------------------------------------
 | Slice selectors
 |------------------------------------------------------------------------------
 */

const getAppEventId = (state) => state.app.event;
const getEntities = (state) => state.domain.entities;
const getPublicEvents = (state) => state.domain.public.events;

/*
 |------------------------------------------------------------------------------
 | Exports
 |------------------------------------------------------------------------------
 */

export const getEventId: (State) => number = createSelector(
  [getAppEventId],
  (x) => x,
);

export const getEvent: (State) => ?BraindateEvent = createSelector(
  [getAppEventId, getEntities],
  (id, entities) => hydrateEvent(id, entities),
);

export const getEventPublicData: (State) => ?BraindateEventPublicData = createSelector(
  [getAppEventId, getPublicEvents],
  (id, events) => events[id],
);

export function getEventSafely(state: State): BraindateEvent {
  // $FlowIssue: FIXME
  return getEvent(state) || getEventPublicData(state);
}
